// One paid state, four spellings: Elavon 'completed'; Payroc 'ready' (authorized) / 'complete' (settled); older rows 'approved'. Mirrors backend COMPLETED_STATUSES.
export const PAID_TRANSACTION_STATUSES = ['completed', 'ready', 'complete', 'approved'];

export const COMPLETED_TRANSACTION_STATUSES = [
  'completed',
  'ready',
  'voided',
  'refunded',
  'partially_refunded'
];

// Voided belongs here: a void reverses the charge, so the patient gets money
// back and a refund receipt to show for it, same as a refund.
export const REFUNDED_TRANSACTION_STATUSES = ['refunded', 'partially_refunded', 'voided'];
